import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Subject } from 'rxjs';
import { takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { AuthenticationService } from '@services/authentication.service';

/**
 * Component
 */
@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnDestroy {

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();
	/** Client ID */
	public client_id = "";
	/** Connection */
	public connection = "";
	/** Language */
	public lang = "";
	/** Error */
	public error = "";
	/** Error Description */
	public error_description = "";
	/** Tracking */
	public tracking = "";

	/**
	 * Default Constructor
	 * @param auth Authentication
	 * @param activatedRoute Activated Route
	 * @param authenticationService Authentication Service
	 */
	constructor(
		public auth: AuthService,
		private activatedRoute: ActivatedRoute,
		private authenticationService: AuthenticationService
	) {

		// Check the Query Parameters
		this.activatedRoute.queryParams.pipe(
			takeUntil(this.finalise),
			distinctUntilChanged()
		).subscribe(
			params => {

				try {
					// Get the GUID for the selected Account to Manage
					this.client_id = params['client_id'];
					this.connection = params['connection'];
					this.lang = params['lang'];
					this.error = params['error'];
					this.error_description = params['error_description'];
					this.tracking = params['tracking'];
				}
				catch (error) { this.error_description = <string>error; }
			}
		)
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * Logout
	 */
	logout() {
		this.authenticationService.logout();
		// console.log(this.doc.location.origin)
		this.auth.logout();
	}
}
